<template>
  <div class="content-center">
    <div class="industrySolutions">
      <div class="title">行业解决方案</div>
      <div class="solutions">
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution1.png" alt="">
          </div>
          <p>家用电器</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution2.png" alt="">
          </div>
          <p>农资行业</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution3.png" alt="">
          </div>
          <p>交通出行</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution4.png" alt="">
          </div>
          <p>酒水饮料</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution5.png" alt="">
          </div>
          <p>家居建材</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution6.png" alt="">
          </div>
          <p>数码3C</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution7.png" alt="">
          </div>
          <p>餐饮行业</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/chainE/chain_industry-solution8.png" alt="">
          </div>
          <p>快消行业</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // name: 'cloud-purchase',
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .industrySolutions {
    height: 475px;
    padding-top: 70px;
    background: url("~@/assets/images/chainE/chain_industry-solution-bg.png") no-repeat;
    .title {
      font-size: 36px;
      color: #fff;
    }
    .solutions {
      display: flex;
      width: 1200px;
      margin: 52px auto 0;
      .item {
        // display: inline-flex;
        width: 110px;
        margin-right: 45px;
        .imgWrap {
          width: 110px;
          height: 110px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        p {
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-top: 15px;
        }
      }
    }
  }
</style>
